// extracted by mini-css-extract-plugin
export default {"w-full":"Control_w-full__3QVMy","control":"Control_control__odBV4","button":"Control_button__C0rpo"};